"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedProjectSchema = exports.SharedProjectChatSchema = exports.UpdateProjectRequestSchema = exports.CreateProjectRequestSchema = exports.ProjectListItemSchema = exports.ProjectSchema = void 0;
const zod_1 = require("zod");
exports.ProjectSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    template: zod_1.z.string().nullable(),
    isPublic: zod_1.z.boolean(),
    forkedFrom: zod_1.z.uuid().nullable(),
    chatCount: zod_1.z.number(),
    lastAccessedAt: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.ProjectListItemSchema = exports.ProjectSchema;
exports.CreateProjectRequestSchema = zod_1.z.object({
    name: zod_1.z.string().min(1),
    description: zod_1.z.string().optional(),
    template: zod_1.z.string().optional(),
});
exports.UpdateProjectRequestSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).optional(),
    description: zod_1.z.string().optional(),
    isPublic: zod_1.z.boolean().optional(),
});
exports.SharedProjectChatSchema = zod_1.z.object({
    description: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.SharedProjectSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    template: zod_1.z.string().nullable(),
    ownerDisplayName: zod_1.z.string().nullable(),
    chatCount: zod_1.z.number(),
    chats: zod_1.z.array(exports.SharedProjectChatSchema),
    forkedFrom: zod_1.z.uuid().nullable(),
    createdAt: zod_1.z.string(),
});
